export const COMMAND_NO_AUTH = 'NO_AUTH'
export const COMMAND_CLOSE_PORT = 'CLOSE_PORT'
export const COMMAND_LOGGED_IN = 'LOGGED_IN'
export const COMMAND_LOGGED_OUT = 'LOGGED_OUT'
export const COMMAND_UPDATED = 'UPDATED'
export const COMMAND_INTERACT = 'INTERACT'